/**
 * Message Subscription
 *
 * Supabase realtime requires a browser-readable Supabase session. This app uses
 * HttpOnly server-side auth cookies, so chat refreshes through authenticated API
 * polling instead of a browser Supabase channel.
 */

import { EnhancedMessage } from "@/types/centralizedChat";
import { MessageServiceContext } from "../services/types";

export interface MessageSubscriptionCallbacks {
  onNewMessage: (message: EnhancedMessage) => void;
  onMarkAsRead?: (conversationId: string) => void;
}

export interface MessageSubscriptionConfig {
  conversationId: string | null;
  context: MessageServiceContext;
  callbacks: MessageSubscriptionCallbacks;
  enabled?: boolean;
}

export class MessageSubscription {
  constructor(_config: MessageSubscriptionConfig) {
    void _config;
  }

  subscribe(): void {
    // Server-side auth intentionally disables browser Supabase realtime.
  }

  cleanup(): void {
    // No browser channel to clean up.
  }

  isActive(): boolean {
    return false;
  }
}
